import { useAppSelector } from 'app/store'

export default function useGradeFilters() {
  return useAppSelector((state) => state.userData.filters[state.userData.grade])
}
